<div class="container compliance-shell">
  @if (action == 'index') {
    <div class="panel-block">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="section-title">Choose Property</h1>
        <button (click)="goBack()" class="btn btn-primary">Back <fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
      </div>
      <div class="form-group has-search">
        <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
        <input type="text" name="search" [(ngModel)]="searchProperty" class="form-control" placeholder="Search by property name">
      </div>
      <ul class="list-group list-group-flush col-md-6 property-list">
        @for (property of properties | filter: searchProperty; track property) {
          <li (click)="onSelectedProperty(property)" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center property-item">
            @if (property.property_type == 'house') {
              <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
            }
            @if (property.property_type == 'strata') {
              <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
            }
            @if (property.property_type == 'vehicle') {
              <fa-icon class="l-icon" [icon]="faCar"></fa-icon>
            }
            <span class="text-black fw-lighter">{{ property.name }}</span>
            <fa-icon [icon]="faCircleArrowRight"></fa-icon>
          </li>
        }
      </ul>
    </div>
  }

  @if (action == 'view') {
    <div class="panel-block">
      <div class="d-flex justify-content-end mt-4 d-print-none">
        <button (click)="goBack()" class="btn btn-primary">Back <fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
      </div>

      @if (pageLoading === true) {
        <div class="d-flex justify-content-center align-items-center compliance-loading-container">
          <div class="compliance-spinner" role="status" aria-live="polite" aria-label="Loading data">
            <span class="sr-only" id="compliance-loading">Loading data</span>
          </div>
          <div class="compliance-loading-text-wrap">
            <p class="compliance-loading-text">Loading data</p>
          </div>
        </div>
      }

      @if (pageLoading === false) {
        <mat-tab-group>
          <mat-tab label="All Data">
            <div id="content" #content class="content-panel">
              <div class="table-header-row">
                <div>
                  <p class="eyebrow">Property overview</p>
                  <h1 class="section-title">Compliance - Premises List</h1>
                </div>
                <div class="d-inline-block d-print-none">
                  <button (click)="printScreen()" class="btn btn-info mx-2"><fa-icon [icon]="faPrint"></fa-icon></button>
                  <button [disabled]="generatingfile" (click)="downloadScreen(property.name)" class="btn btn-info mx-2">
                    @if (!generatingfile) {
                      <fa-icon [icon]="faDownload"></fa-icon>
                    }
                    @if (generatingfile) {
                      <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                  </button>
                </div>
              </div>

              <div class="summary-grid mb-4">
                <div class="stat-card">
                  <span class="stat-label">Compliance</span>
                  <strong>{{ summaryStats.compliancePercentage | number: '1.1-1' }}%</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Units compliant</span>
                  <strong>{{ summaryStats.compliantUnits }}</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Outstanding balance</span>
                  <strong>{{ summaryStats.outstandingValue | currency }}</strong>
                </div>
              </div>

              <div class="form-group my-4">
                <label class="form-label" for="property_name">Property Name</label>
                <input class="form-control col-3" type="text" placeholder="Property name" [value]="property.name" readonly />
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-bordered align-middle">
                  <thead class="table-light">
                    <tr>
                      <th scope="col">APT/LOT# <button class="btn btn-sm btn-link d-print-none" (click)="toggleSort()"><fa-icon [icon]="faSort"></fa-icon></button></th>
                      <th scope="col"># Months Outstanding</th>
                      <th scope="col">Last Maintenance Paid</th>
                      <th scope="col">Total Maintenance Paid <button class="btn btn-sm btn-link d-print-none" (click)="togglePSort()"><fa-icon [icon]="faSort"></fa-icon></button></th>
                      <th scope="col">Total Maintenance Outstanding <button class="btn btn-sm btn-link d-print-none" (click)="toggleMSort()"><fa-icon [icon]="faSort"></fa-icon></button></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (premise of complianceList | orderBy: 'unit_number' : sortOrder; track premise) {
                      <tr>
                        <td>{{ premise.unit_number }}</td>
                        <td>{{ getOutstandingMonths(premise) }}</td>
                        <td>{{ getDisplayDate(premise) }}</td>
                        <td>{{ premise.totalmaintenancepaid | currency }}</td>
                        <td>{{ premise.totalmaintenanceoutstanding | currency }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="By Month">
            <div class="panel-block">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h1 class="section-title">Compliance - By Month</h1>
              </div>

              <div class="summary-grid mb-4">
                <div class="stat-card">
                  <span class="stat-label">Current month</span>
                  <strong>{{ monthlyBreakdown[monthlyBreakdown.length - 1]?.percentage || 0 | number: '1.1-1' }}%</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Units compliant</span>
                  <strong>{{ monthlyBreakdown[monthlyBreakdown.length - 1]?.units || 0 }}</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Outstanding</span>
                  <strong>{{ monthlyBreakdown[monthlyBreakdown.length - 1]?.outstanding || 0 }}</strong>
                </div>
              </div>

              <div class="form-group my-4">
                <label class="form-label">Property Name</label>
                <input class="form-control col-3" type="text" [value]="property.name" readonly />
              </div>

              <div class="chart-panel mb-4">
                <canvas baseChart
                  [type]="'line'"
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  [legend]="lineChartLegend">
                </canvas>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-bordered align-middle">
                  <thead class="table-light">
                    <tr>
                      <th scope="col">Month</th>
                      <th scope="col">Units compliant</th>
                      <th scope="col">Compliance %</th>
                      <th scope="col">Outstanding units</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (month of monthlyBreakdown; track month.label) {
                      <tr>
                        <td>{{ month.label }}</td>
                        <td>{{ month.units }}</td>
                        <td>{{ month.percentage | number: '1.1-1' }}%</td>
                        <td>{{ month.outstanding }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="By Year">
            <div class="panel-block">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h1 class="section-title">Compliance - Numbers</h1>
                <button (click)="goBack()" class="btn btn-primary">Back <fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
              </div>

              <div class="summary-grid mb-4">
                <div class="stat-card">
                  <span class="stat-label">Compliance</span>
                  <strong>{{ summaryStats.compliancePercentage | number: '1.1-1' }}%</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Current period</span>
                  <strong>{{ summaryStats.currentPeriodCompliant }}</strong>
                </div>
                <div class="stat-card">
                  <span class="stat-label">Total units</span>
                  <strong>{{ summaryStats.totalUnits }}</strong>
                </div>
              </div>

              <form [formGroup]="complianceDataForm" class="stats-form">
                <div class="form-group my-4">
                  <label class="form-label" for="property_name">Property Name</label>
                  <input class="form-control" type="text" placeholder="Property name" formControlName="property_name" />
                </div>
                <div class="form-group">
                  <label class="form-label">Property Type</label>
                  <select class="form-control" formControlName="property_type">
                    <option value="strata">Strata</option>
                    <option value="house">House</option>
                    <option value="hotel">Hotel</option>
                  </select>
                </div>
                <div class="form-group my-4">
                  <label class="form-label" for="number_units">Number of units</label>
                  <input class="form-control" placeholder="Number of units/apartments" formControlName="number_units" />
                </div>
                <div class="form-group my-4">
                  <label class="form-label" for="number_units">Number of units compliant YTD</label>
                  <input class="form-control" placeholder="Number of units/apartments" formControlName="compliantnumberytd" readonly />
                </div>
                <div class="form-group my-4">
                  <label class="form-label" for="number_units">Number of units compliant current period</label>
                  <input class="form-control" placeholder="Number of units/apartments" formControlName="currentnumbercompliant" readonly />
                </div>
                <div class="form-group my-4">
                  <label class="form-label" for="number_units">Percentage compliance</label>
                  <input class="form-control" placeholder="Number of units/apartments" formControlName="percentageytd" readonly />
                </div>
              </form>

              <h1 class="section-title mt-4">Compliance - Charts</h1>
              <div class="chart-grid">
                <div class="chart-panel">
                  <canvas baseChart
                    [type]="'pie'"
                    [datasets]="pieChartDatasets"
                    [labels]="pieChartLabels"
                    [options]="pieChartOptions"
                    [plugins]="pieChartPlugins"
                    [legend]="pieChartLegend">
                  </canvas>
                </div>

                <div class="chart-panel">
                  <canvas baseChart
                    [data]="barChartData"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    [type]="'bar'">
                  </canvas>
                </div>

                <div class="chart-panel chart-panel-wide">
                  <canvas baseChart
                    [type]="'line'"
                    [data]="lineChartData"
                    [options]="lineChartOptions"
                    [legend]="lineChartLegend">
                  </canvas>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      }
    </div>
  }
</div>

